export class CifradoUtils {

	constructor() { }

	/**
	 * Metodo para desencriptar una cadena de texto en base64
	 * @param str Cadena encriptada
	 */
	public static b64DecodeUnicode(str) {

		return decodeURIComponent(atob(str).split('').map(function (c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	}
}